import React from 'react';
import { EmailBlock, LayoutBlockContent } from '../types';
import { BlockRenderer } from '../components/BlockRenderer';

interface RowBlockProps {
  block: EmailBlock;
  isSelected: boolean;
  onSelect: () => void;
  isDarkMode: boolean;
}

export const RowBlock: React.FC<RowBlockProps> = ({
  block,
  isSelected,
  onSelect,
  isDarkMode
}) => {
  const content = block.content as LayoutBlockContent;

  const style: React.CSSProperties = {
    backgroundColor: content.backgroundColor || 'transparent',
    padding: content.padding || '0',
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    ...block.styles
  };

  return (
    <div style={style}>
      {block.children && block.children.length > 0 ? (
        block.children.map((child) => (
          <BlockRenderer
            key={child.id}
            block={child}
            isSelected={false}
            onSelect={onSelect}
            isDarkMode={isDarkMode}
          />
        ))
      ) : (
        <div className={`
          flex-1 p-4 border-2 border-dashed rounded text-center
          ${isDarkMode ? 'border-gray-600 text-gray-400' : 'border-gray-300 text-gray-500'}
        `}>
          Empty row - add columns or content
        </div>
      )}
    </div>
  );
};
